<!-- "Similar registrations for sale" — reuses the existing PlateX search
     results (SearchService). Hidden entirely when there is nothing to show and
     we are no longer loading, so the page never displays an empty shell. -->
<section
  class="pdv2-similar"
  *ngIf="loading || cards.length > 0"
  id="sec-similar"
>
  <div class="sim-head">
    <div class="sim-head-text">
      <div class="sim-eyebrow">Live marketplace</div>
      <h2 class="sim-title">Similar registrations for sale</h2>
      <p class="sim-sub" *ngIf="reading">
        Plates that also read as {{ reading }}, then comparable plates,
        currently listed across verified dealers.
      </p>
      <p class="sim-sub" *ngIf="!reading">
        Comparable plates derived from this registration, currently listed
        across verified dealers.
      </p>
    </div>
    <button type="button" class="sim-browse" (click)="browseAll()">
      Browse all registrations →
    </button>
  </div>

  <!-- Lightweight skeleton while the (often cached) search resolves. -->
  <div class="sim-grid" *ngIf="loading">
    <div class="sim-card is-skeleton" *ngFor="let s of [1, 2, 3, 4]">
      <div class="sk-plate"></div>
      <div class="sk-line sk-line-a"></div>
      <div class="sk-line sk-line-b"></div>
    </div>
  </div>

  <!-- Real cards. -->
  <div class="sim-grid" *ngIf="!loading">
    <button
      type="button"
      class="sim-card"
      *ngFor="let card of cards"
      (click)="openCard(card)"
    >
      <div class="sim-plate">
        <pla-plate
          [rawPlate]="card.formattedRegistration"
          [white]="false"
          [mobileSmall]="false"
          [openModal]="false"
          [showPrice]="false"
          [useCustom]="true"
          [customSize]="9"
          [customFontSize]="38"
        ></pla-plate>
      </div>

      <div class="sim-price">
        <span class="sim-price-from">from</span>
        <span class="sim-price-amt">{{
          card.pricePence / 100 | currency : 'GBP' : 'symbol' : '1.0-0'
        }}</span>
      </div>

      <div class="sim-reason" *ngIf="card.reason">
        <span class="sim-dot" aria-hidden="true"></span>
        <span class="sim-reason-text">{{ card.reason }}</span>
      </div>
    </button>
  </div>

  <!-- Honest limitation note (only the dateless structured-search fallback). -->
  <p class="sim-note" *ngIf="!loading && note">{{ note }}</p>
</section>
